const Utils = {
  ConvertStringToHTML(str) {
    let parser = new DOMParser()
    let doc = parser.parseFromString(str, 'text/html')
    return doc.body
  },
  ConvertStringToJS(str) {
    var script = document.createElement("script")
    script.text = str
    document.head.appendChild(script).parentNode.removeChild(script)
  },
  async PromisesSequential(PromiseArr) {
    let res = [];
    for (let i=0; i < PromiseArr.length; i++) {
      res.push(await PromiseArr[i])
    }
    return res
  },
  OnMutate(targetNodes, callback) {
    var observer = new MutationObserver(callback);

    // Notify me of everything!
    var observerConfig = {
      attributes: true, 
      childList: true, 
      characterData: true
    };

    targetNodes.forEach((node) => {
      observer.observe(node, observerConfig);
    });
  }
};

document.addEventListener('alpine:init', () => {
  Alpine.data('CollectionLoadMore', (_collection) => ({
    collection: _collection,
    cache: {},
    flags: {
      loading: true
    },
    init() {
      let am = this;
      am.InitSelf();
      am.LoadAllPages();
    },
    InitSelf() {
      let am = this;
      am.cache.$section = am.$el;
    },
    LoadAllPages() {
      let am = this;
      let section_id = am.$el.dataset.section_id;
      let view = am.$el.dataset.view || '';

      (async () => {
        let urls = []
        for (let i = 2; i <= am.collection.paginate.pages; i++) {
          urls.push(`${ window.location.href }?&page=${ i }&sections=${ section_id }&view=${ view }`)
        }
        // console.log(urls);
        let px_urls = urls.map(async(url) => {
          return await fetch(url).then(res => res.json())
        })

        let px_res = await Utils.PromisesSequential(px_urls)
        px_res.forEach((res) => {
          let $res_section = Utils.ConvertStringToHTML(res[section_id]);
          // console.log($res_section);

          let $products = $res_section.querySelectorAll('[data-product-item]');
          $products.forEach(($product) => {
            am.cache.$section.insertAdjacentElement('beforeend', $product);
            $product.setAttribute('data-transition-active', 'true');
          });

          am.flags.loading = false;
        })
      })()
    }
  }));

  Alpine.data('BlackListSignupForm', () => ({
    form_type: ''
  }));
});